module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqbahnLabs3.c32da68a.png";